import * as Yup from 'yup';
import { useState } from 'react';
// form
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
// @mui
import { Stack, Card, IconButton, InputAdornment } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// @types
import { IUserAccountChangePassword } from 'src/types/user';
// components
import Iconify from '../../components/iconify';
import { useSnackbar } from '../../components/snackbar';
import FormProvider, { RHFTextField } from '../../components/hook-form';
import axios from '../../utils/axios';
// ----------------------------------------------------------------------

type FormValuesProps = IUserAccountChangePassword;

export default function AccountChangePassword() {
  const { enqueueSnackbar } = useSnackbar();

  const accessToken = localStorage.getItem('accessToken');

  const ChangePassWordSchema = Yup.object().shape({
    oldPassword: Yup.string().required('Mật khẩu phải bắt buộc'),
    newPassword: Yup.string()
      .min(6, 'Mật khẩu phải lớn hơn 6 ký tự')
      .required('Mật khẩu phải bắt buộc'),
    confirmNewPassword: Yup.string()
      .oneOf([Yup.ref('newPassword')], 'Mật khẩu mới phải trùng nhau')
      .required('Xác nhận lại mật khẩu'),
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);


  const defaultValues = {
    oldPassword: '',
    newPassword: '',
    confirmNewPassword: '',
  };

  const methods = useForm({
    resolver: yupResolver(ChangePassWordSchema),
    defaultValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (data: FormValuesProps) => {
    try {
      axios
        .put(`hosons/change-password`, data, {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${accessToken}`,
          },
        })
        .then((res) => {
          enqueueSnackbar('Mật khẩu đã được thay đổi thành công!', { variant: 'success', autoHideDuration: 4000 });
        })
        .catch((error) => {
          if (error.response) {

            enqueueSnackbar(`${error.response.data.message}`, {
              variant: 'error',
              autoHideDuration: 4000,
            });
          } else if (error.request) {
            enqueueSnackbar(
              `Không nhận được phản hồi từ máy chủ`, {
              variant: 'error',
              autoHideDuration: 4000
            });
          } else {
            enqueueSnackbar(`Lỗi gửi yêu cầu`, {
              variant: 'error',
              autoHideDuration: 4000,
            });
          }
        });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Card>
        <Stack spacing={3} alignItems="flex-end" sx={{ p: 3 }}>
          <RHFTextField
            name="oldPassword"
            type={showPassword ? "text" : "password"}
            label="Mật khẩu cũ"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                    <Iconify icon={showPassword ? "eva:eye-off-fill" : "eva:eye-fill"} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <RHFTextField
            name="newPassword"
            type={showNewPassword ? "text" : "password"}
            label="Mật khẩu mới"
            helperText={
              <Stack component="span" direction="row" alignItems="center">
                <Iconify icon="eva:info-fill" width={16} sx={{ mr: 0.5 }} /> Mật khẩu phải tối thiểu 6 ký tự
              </Stack>
            }
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowNewPassword(!showNewPassword)} edge="end">
                    <Iconify icon={showNewPassword ? "eva:eye-off-fill" : "eva:eye-fill"} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <RHFTextField
            name="confirmNewPassword"
            type={showConfirmPassword ? "text" : "password"}
            label="Xác nhận mật khẩu mới"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)} edge="end">
                    <Iconify icon={showConfirmPassword ? "eva:eye-off-fill" : "eva:eye-fill"} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
            Lưu thay đổi
          </LoadingButton>
        </Stack>
      </Card>
    </FormProvider>
  );
}
